import React from "react";
import { Box, Typography, Grid, Divider, Container } from "@mui/material";
import DotPattern from "../assets/Images/Dot2.png"; // optional background
import Logo from "../assets/Images/Logo.png"; // replace with actual path
import Header from "../components/Navbar";
import Footer from "../components/Footer";

const Section = ({ title, children }) => (
  <Box mb={5}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body1" color="textSecondary">
      {children}
    </Typography>
  </Box>
);

const PrivacyPolicyPage = () => {
  return (
    <>
    <Header />
    <Box
      sx={{
        backgroundColor: "#F9FAFB",
        backgroundImage: `url(${DotPattern})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top right",
        backgroundSize: "200px",
        minHeight: "100vh",
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Grid container justifyContent="center" mb={4}>
          {/* <img src={Logo} alt="Ajoo Logo" style={{ maxHeight: 80 }} href="/"/> */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{ mr: 2, mt: 1 }}
          >
            <img alt="logo" src={Logo}></img>
          </Typography>
        </Grid>

        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Effective Date: May 2, 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Section title="1. Information We Collect">
          We collect personal details such as your name, email address, group membership details, and app usage data. We may also collect device-related information like your OS and device model.
        </Section>

        <Section title="2. How We Use Your Information">
          We use your data to provide core functionalities, improve app performance, enable group management, and communicate important updates.
        </Section>

        <Section title="3. Sharing of Information">
          Ajoo does not sell your personal information. We may share it with trusted service providers to operate essential services such as authentication or storage.
        </Section>

        <Section title="4. Data Security">
          Your data is protected using encryption and strict access controls. While we strive for maximum security, no system is 100% immune from risk.
        </Section>

        <Section title="5. Your Rights">
          You can request to view, modify, or delete your personal data by contacting us at ajooomobile@gmail.com.
        </Section>

        <Section title="6. Data Retention">
          We only retain your data for as long as necessary to fulfill our services and legal obligations.
        </Section>

        <Section title="7. Third-Party Links">
          Our app may link to third-party services. We are not responsible for their privacy practices and recommend reviewing their policies.
        </Section>

        <Section title="8. Children's Privacy">
          Ajoo is not intended for children under 13. We do not knowingly collect data from minors.
        </Section>

        <Section title="9. Changes to This Policy">
          We may update this Privacy Policy. Continued use of Ajoo after changes means you agree to the updated terms.
        </Section>

        <Section title="10. Contact Us">
          If you have questions, contact us at <strong>ajooomobile@gmail.com</strong>.
        </Section>
      </Container>
    </Box>
    <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
